class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.querySelector('.cart-notification');
    if (!this.notification) return;

    this.header = document.querySelector('theme-header');
    this.overlayPopup = this.querySelector('.cart-notification-overlay-poup');
    this.closeButtons = this.querySelectorAll('button[type="button"]');

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onEscapePress = this.handleEscapePress.bind(this);

    this.notification.addEventListener('keyup', this.onEscapePress);
    this.closeButtons.forEach(btn => btn.addEventListener('click', () => this.close()));
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');
    if (this.overlayPopup) {
      this.overlayPopup.classList.add('active');
      this.overlayPopup.addEventListener('click', this.onBodyClick, { once: true });
    }

    if ('vibrate' in navigator) navigator.vibrate(200);

    this.notification.addEventListener(
      'transitionend',
      () => this.notification.focus(),
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick, { passive: true });
  }

  close() {
    if (!this.notification?.classList.contains('active')) return; 

    this.notification.classList.remove('active', 'animate');
    document.body.removeEventListener('click', this.onBodyClick);

    if (this.overlayPopup) this.overlayPopup.classList.remove('active');
  }

  renderContents(parsedState) {
    if (!parsedState?.sections) return;

    this.cartItemKey = parsedState.key;
    const parser = new DOMParser();

    this.getSectionsToRender().forEach(({ id, selector }) => {
      const container = document.getElementById(id);
      if (!container) return;

      const html = parsedState.sections[id];
      if (!html) return;

      const sectionContent = parser.parseFromString(html, 'text/html').querySelector(selector);
      if (sectionContent) container.innerHTML = sectionContent.innerHTML;
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: '[id="cart-notification-product-1"]',
      },
    ];
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (!target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure?.querySelector('summary') || null;
    }
    this.close();
  }

  handleEscapePress(evt) {
    if (evt.code === 'Escape') this.close();
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
